'use strict'; // http://ecma-international.org/ecma-262/5.1/#sec-9.2

module.exports = function ToBoolean(value) {
  return !!value;
};